import { render, staticRenderFns } from "./BatchCourseScheduleDefinition.vue?vue&type=template&id=703e9476&"
import script from "./BatchCourseScheduleDefinition.vue?vue&type=script&lang=js&"
export * from "./BatchCourseScheduleDefinition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports